export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-instagram-11f7c4d539b843ca92fb831298ba7188.svg";